export default __webpack_public_path__ + "static/Angel-dda1a0c7c89770d631f2159975b612fd.png";